module.exports = __webpack_public_path__ + "static/media/short-arrow-b-green.433fbe07.svg";